import { useSubscription } from "@apollo/react-hooks";
import { Avatar, Dropdown, Layout, Menu } from "antd";
import moment from "moment";
import momentTz from "moment-timezone";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  GET_DASHBOARD_WEEKLY_TASK_COUNT,
  GET_USER_NOTIFICATION,
  USER_TIMEZONE_SUBSCRIPTION,
} from "../../../Graphql/subscriptions";
import { logout } from "../../../Utils/functions/common";
import { SealShareModal } from "../../Modals/SealShareModal/SealShareModal";
import { CustIcon } from "../../Svgs";
import "./DashboardHeader.less";
import NotificationMenu from "./Notification/NotificationMenu";

const { Header } = Layout;
const { REACT_APP_ASSETS_URL } = process.env;

export const DashboardHeader = ({
  toggleSideBarMenu,
  isSideBarOpen,
  initials,
  pageName,
  src,
  userData,
}) => {
  const [currentTime, setCurrentTime] = useState(
    momentTz.tz(moment(), momentTz.tz.guess()).format("LLLL zz")
  );
  const location = useLocation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [totalTasksAssignedLastWeek, setTotalTasksAssignedLastWeek] =
    useState(0);
  const [totalTasksCompletedLastWeek, setTotalTasksCompletedLastWeek] =
    useState(0);

  const { data: userTimezoneData } =
    useSubscription(USER_TIMEZONE_SUBSCRIPTION, {
      variables: {
        user_id: localStorage.getItem("user_id"),
      },
    });
  const { data: weeklyTaskData, loading: weeklyTaskDataLoading } =
    useSubscription(GET_DASHBOARD_WEEKLY_TASK_COUNT, {
      variables: {
        user_id: localStorage.getItem("user_id"),
        start_date: moment
          .tz(moment(), userTimezoneData?.getUsersById.time_zone)
          .subtract(8, "days")
          .format("YYYY-MM-DD"),
        end_date: moment
          .tz(moment(), userTimezoneData?.getUsersById.time_zone)
          .subtract(1, "days")
          .format("YYYY-MM-DD"),
      },
      skip: !userTimezoneData,
    });

  const { data: userNotificationData, loading: userNotificationDataLoading } =
    useSubscription(GET_USER_NOTIFICATION, {
      variables: {
        user_id: localStorage.getItem("user_id"),
      },
      fetchPolicy: "cache-and-network",
    });

  useEffect(() => {
    const urlName = location.pathname
      .substring(location.pathname.lastIndexOf("/") + 1)
      .replaceAll("-", " ");
    if (urlName) {
      const arr = [];
      urlName.split(" ").forEach((name) => {
        arr.push(name[0].toUpperCase() + name.slice(1));
      });
      document.title = `Sanattest | ${arr.toString().replaceAll(",", " ")}`;
    } else {
      document.title = `Sanattest | Dashboard`;
    }
  });

  useEffect(() => {
    if (weeklyTaskData) {
      let allTaskCount = weeklyTaskData.user_reporting_view.reduce(
        (acc, curr) => {
          let countObj =
            curr.subordinate_details.user_tasks_status_by_date_aggregate
              .aggregate.sum;
          let sumOfAll = Object.keys(countObj).reduce((sum, key) => {
            if (typeof countObj[key] === "number") {
              return sum + parseFloat(countObj[key] || 0);
            } else {
              return sum;
            }
          }, 0);
          return acc + sumOfAll;
        },
        0
      );
      let completedTaskCount = weeklyTaskData.user_reporting_view.reduce(
        (acc, curr) => {
          let countObj =
            curr.subordinate_details.user_tasks_status_by_date_aggregate
              .aggregate.sum;
          return acc + countObj.completed;
        },
        0
      );
      setTotalTasksAssignedLastWeek(allTaskCount);
      setTotalTasksCompletedLastWeek(completedTaskCount);
    }
  }, [weeklyTaskData]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(
        momentTz.tz(moment(), momentTz.tz.guess()).format("LLLL zz")
      );
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const onShowModal = () => {
    if (
      Math.ceil(
        (totalTasksCompletedLastWeek / totalTasksAssignedLastWeek) * 100
      ) > 80
    ) {
      setIsModalVisible(true);
    }
  };

  const onHideModal = () => {
    setIsModalVisible(false);
  };
  return (
    <Header className="site-header-layout">
      <div className="hamburgar" onClick={toggleSideBarMenu}>
        <CustIcon
          type="right-arrow"
          className={`${isSideBarOpen ? "" : "open"}`}
        />
      </div>
      <div className="leftHeader">
        <div className="pageTitle">
          <h2>{pageName}</h2>
          <p>{currentTime}</p>
        </div>
      </div>
      <div className="rightHeader">
        <ul className="d-flex list-inline">
          <li>
            <div onClick={onShowModal}>
              <CustIcon type="medal" className="card-color-4 share-medal" />
            </div>
            {isModalVisible && (
              <SealShareModal
                onShowModal={onShowModal}
                onHideModal={onHideModal}
                isModalVisible={isModalVisible}
                userData={userData}
                count={
                  !!totalTasksCompletedLastWeek && !!totalTasksAssignedLastWeek
                    ? !weeklyTaskDataLoading &&
                      Math.ceil(
                        (totalTasksCompletedLastWeek /
                          totalTasksAssignedLastWeek) *
                          100
                      )
                    : "0"
                }
              />
            )}
          </li>
          <li>
            <Dropdown
              placement="bottomRight"
              overlay={
                <NotificationMenu
                  userNotificationData={userNotificationData}
                  userNotificationDataLoading={userNotificationDataLoading}
                />
              }
              trigger="click"
              overlayClassName="notifiaction_popover"
            >
              <span
                className={`notification ${
                  userNotificationData?.notification_users?.length > 0
                    ? "active"
                    : ""
                }`}
              >
                <CustIcon type="notification" />
              </span>
            </Dropdown>
          </li>
          <li>
            <Dropdown
              trigger={["click"]}
              overlay={profileMenu}
              placement="bottomRight"
              overlayClassName="userDropdown"
              arrow
            >
              {src ? (
                <Avatar src={REACT_APP_ASSETS_URL + src} />
              ) : (
                <Avatar>{initials}</Avatar>
              )}
            </Dropdown>
          </li>
        </ul>
      </div>
    </Header>
  );
};

const profileMenu = (
  <Menu>
    <Menu.Item>
      <Link alt="Profile" to="/settings/profile">
        My Profile
      </Link>
    </Menu.Item>
    <Menu.Item>
      <Link alt="Change Password" to="/settings/change-password">
        Change Password
      </Link>
    </Menu.Item>
    <Menu.Item>
      <Link
        onClick={() => {
          logout();
        }}
      >
        Logout
      </Link>
    </Menu.Item>
  </Menu>
);
